import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api/client";

/**
 * Module-singleton QueryClient so the 401 interceptor and AuthProvider can
 * `clear()` the cache without going through React context.
 * Defaults: retry only on 5xx (never 4xx), no refetch on window focus, 30s stale.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 500) {
          return failureCount < 2;
        }
        return false;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
